var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "fill-height posRelative" },
    [
      _c(
        "v-layout",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.dragOverStatus,
              expression: "!dragOverStatus"
            }
          ],
          staticClass: "fill-height ma-0",
          attrs: { row: "", wrap: "" }
        },
        [
          _c(
            "v-flex",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.bigWidthChat || !_vm.bigHeightChat,
                  expression: "!bigWidthChat || !bigHeightChat"
                }
              ],
              staticClass: "pa-0 fill-height",
              class: {
                afficheInfos: _vm.afficheInfos,
                cacheInfos: !_vm.afficheInfos,
                mobileShowInfosVisiteur: _vm.$vuetify.breakpoint.xsOnly,
                xs7: _vm.bigHeightChat,
                xs12: !_vm.bigHeightChat,
                "infos-panel--large": !_vm.bigHeightChat
              }
            },
            [
              _vm.dataCompletVisiteur && _vm.chatSessionActive
                ? _c("wz-content-infos-visiteur", {
                    ref: "infos",
                    staticClass: "cardInfosVisiteurPupitre",
                    attrs: {
                      datasVisiteur: _vm.dataCompletVisiteur,
                      datasPupitreVisiteur: _vm.datasViewPupitre,
                      placesPupitre: _vm.placesPupitre,
                      selectedAgent: _vm.selectedAgent,
                      msg: _vm.msg
                    },
                    on: {
                      "update:msg": function($event) {
                        _vm.msg = $event
                      },
                      sendMsg: function(msg) {
                        return _vm.$refs.fenetreChat.sendMessage(msg)
                      },
                      cacheInfosVisiteur: _vm.cacheInfosVis
                    }
                  })
                : !_vm.dataCompletVisiteur && _vm.chatSessionActive
                ? _c(
                    "div",
                    { staticClass: "flex" },
                    [
                      _c(
                        "v-alert",
                        { attrs: { type: "warning", value: true } },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.$t("noDataVisiteur")) +
                              "\n        "
                          )
                        ]
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-flex",
            {
              staticClass: "pa-0",
              class: {
                xs5: !_vm.bigWidthChat || !_vm.$vuetify.breakpoint.xsOnly,
                xs12:
                  _vm.bigWidthChat ||
                  !_vm.bigHeightChat ||
                  _vm.$vuetify.breakpoint.xsOnly,
                "chat-panel--reduce": !_vm.bigHeightChat
              }
            },
            [
              _vm.dataCompletVisiteur && _vm.chatSessionActive
                ? _c("wz-fenetre-chat", {
                    ref: "fenetreChat",
                    attrs: {
                      datasVisiteur: _vm.dataCompletVisiteur,
                      loadingChat: _vm.loadingChat,
                      msg: _vm.msg
                    },
                    on: {
                      reloadHistoChat: _vm.openChat,
                      bigChat: function($event) {
                        _vm.bigHeightChat = true
                      },
                      smallChat: function($event) {
                        _vm.bigHeightChat = false
                      },
                      bigWidthChat: function($event) {
                        _vm.bigWidthChat = true
                      },
                      smallWidthChat: function($event) {
                        _vm.bigWidthChat = false
                      },
                      "update:datasVisiteur": function($event) {
                        _vm.dataCompletVisiteur = $event
                      },
                      "update:datas-visiteur": function($event) {
                        _vm.dataCompletVisiteur = $event
                      },
                      "update:msg": function($event) {
                        _vm.msg = $event
                      },
                      sendReponseAttente: _vm.sendReponseAttente,
                      chatSessionSelect: _vm.chatSessionSelected,
                      afficheInfosVisiteur: _vm.afficheInfosVis,
                      openScreensharing: function(visiteurId) {
                        return _vm.$refs.infos.openScreensharing(visiteurId)
                      }
                    }
                  })
                : !_vm.dataCompletVisiteur && _vm.chatSessionActive
                ? _c(
                    "div",
                    { staticClass: "flex" },
                    [
                      _c(
                        "v-alert",
                        { attrs: { type: "warning", value: true } },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.$t("noDataChat")) +
                              "\n        "
                          )
                        ]
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          (_vm.dataCompletVisiteur &&
            _vm.datasViewPupitre.visiteurDatas.newMessage &&
              !_vm.datasViewPupitre.visiteurDatas.network &&
              _vm.routeNameChatting) ||
          (_vm.dataCompletVisiteur &&
            _vm.datasViewPupitre.visiteurDatas.network &&
              _vm.datasViewPupitre.visiteurDatas.networkFirstMessage)
            ? _c(
                "div",
                { staticClass: "dialogueNewChat" },
                [
                  _c(
                    "v-card",
                    { staticClass: "ContentDialogNewChat" },
                    [
                      _c(
                        "v-card-title",
                        { staticClass: "primary white--text subheading" },
                        [_vm._v(_vm._s(_vm.$t("titreNewChat")))]
                      ),
                      _vm._v(" "),
                      _c("v-card-text", [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.$t("txtContentNewChat")) +
                            " " +
                            _vm._s(_vm.dataCompletVisiteur.visiteurID) +
                            ".\n        "
                        )
                      ]),
                      _vm._v(" "),
                      _c("v-spacer"),
                      _vm._v(" "),
                      _c(
                        "v-card-actions",
                        [
                          _c(
                            "v-btn",
                            {
                              staticClass: "blue--text darken-1",
                              attrs: { flat: "" },
                              on: {
                                click: function($event) {
                                  return _vm.openFirstChat()
                                }
                              }
                            },
                            [_vm._v("OK\n          ")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _vm.dragOverStatus &&
      _vm.dragOverElement.index !=
        _vm.dragOverElement.dataDrop.placePupitreActif - 1
        ? _c(
            "v-container",
            { attrs: { "fill-height": "" } },
            [
              _c(
                "v-layout",
                {
                  staticStyle: { height: "200px" },
                  attrs: { "align-center": "", "justify-center": "", row: "" }
                },
                [
                  _c(
                    "v-card",
                    [
                      _c(
                        "v-card-title",
                        { staticClass: "primary white--text subheading" },
                        [_vm._v(_vm._s(_vm.$t("changePlace")))]
                      ),
                      _vm._v(" "),
                      _c("v-card-text", [
                        _c("div", {
                          domProps: { innerHTML: _vm._s(_vm.changePlaceText) }
                        })
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm.dragOverStatus &&
          _vm.dragOverElement.index ==
            _vm.dragOverElement.dataDrop.placePupitreActif - 1
        ? _c(
            "v-container",
            { attrs: { "fill-height": "" } },
            [
              _c(
                "v-layout",
                {
                  staticStyle: { height: "200px" },
                  attrs: { "align-center": "", "justify-center": "", row: "" }
                },
                [
                  _c(
                    "v-card",
                    [
                      _c(
                        "v-card-title",
                        { staticClass: "primary white--text subheading" },
                        [_vm._v(_vm._s(_vm.$t("changePlace")))]
                      ),
                      _vm._v(" "),
                      _c("v-card-text", [
                        _c("div", {
                          domProps: { innerHTML: _vm._s(_vm.changePlaceText2) }
                        })
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-33147eda", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-33147eda","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/watcheebox/WzViewChat.vue
// module id = null
// module chunks = 